import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import VIPSimpleCallCard from "./VIPSimpleCallCard";
import { getCorsHeaders } from './utils/corsHeaders';
import { getUrlParams } from './utils/urlParams';

const VIPPage = () => {
    const { vipId } = useParams();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [vipConfig, setVipConfig] = useState(() => {
        const savedData = sessionStorage.getItem("VIPConfig");
        try {
            return savedData ? JSON.parse(savedData) : null; // Attempt to parse the saved data
        } catch (error) {
            console.error("Error parsing VIPConfig from sessionStorage:", error);
            return null; // Return null if parsing fails
        }
    });
    const [label, setLabel] = useState('');
    const [design, setDesign] = useState('');
    const [contact, setContact] = useState('');
    const [submitInfo, setIsSubmitInfo] = useState(false);
    const [token, setToken] = useState(null);
    const [customColor, setCustomColor] = useState('');
    const [customFont, setCustomFont] = useState('');
    const [customBackgroundColor, setCustomBackgroundColor] = useState('');
    const [customTextColor, setCustomTextColor] = useState('');

    useEffect(()=>{
        sessionStorage.removeItem("VIPConfig");

    }, [location.search, location.hash])

    useEffect(() => {
        const searchParams = getUrlParams(location);
        const tokenParam = searchParams.get('token');
        const submitInfoParam = searchParams.get('submit') === 'false';
        console.log(submitInfoParam + "p")

        if (tokenParam && tokenParam !== token) {
            setToken(tokenParam);
            sessionStorage.setItem('token', tokenParam);
        }
        else if (!tokenParam) {
            setToken(null);
            sessionStorage.removeItem('token');
        }
        setIsSubmitInfo(submitInfoParam);
        console.log(submitInfo + "'")

    }, [location.search, location.hash]);

    const fetchVIPDataByName = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/get_vip_config_by_name/${vipId}`, {
                method: 'GET',
                headers: getCorsHeaders(),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            if (Array.isArray(data) && data[1] === 404) {
                throw new Error(data[0].message);
            }

            setVipConfig(data);
            return data;
        } catch (error) {
            console.error('Error fetching VIP data by name:', error);
            throw error;
        }
    };

    const fetchVIPDataByNameAndToken = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/get_vip_config_by_name_and_token/${vipId}/${sessionStorage.getItem('token')}`,
                {
                    method: 'GET',
                    headers: getCorsHeaders(),
                }
            );

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            if (Array.isArray(data) && data[1] === 404) {
                throw new Error(data[0].message);
            }
            setVipConfig(data);
            return data;
        } catch (error) {
            console.error('Error fetching VIP data by name and token:', error);
            throw error;
        }
    };

    const fetchVIPData = useCallback(async () => {
        console.log('Fetching Data ...');
        setIsLoading(true);
        const tokenParam = sessionStorage.getItem('token')
        if (!vipConfig) {
            try {
                if (tokenParam) {
                    await fetchVIPDataByNameAndToken();
                } else {
                    await fetchVIPDataByName();
                }
                sessionStorage.setItem("VIPConfig", JSON.stringify(vipConfig))
            } catch (error) {
                console.error('Error in fetching');
                setVipConfig(null);
            } finally {
                setIsLoading(false);
            }
        }
        else{
           setIsLoading(false)
        }
    }, [vipId, token, location.search]);

    useEffect(() => {
        if (vipId) {
            fetchVIPData();
        }
    }, [fetchVIPData, vipId]);

    useEffect(() => {
        const searchParams = getUrlParams(location);
        const designParam = searchParams.get('design');
        const labelParam = searchParams.get('label');
        const contactParam = searchParams.get('contact');
        const customColorParam = searchParams.get('customColor');
        const customFontParam = searchParams.get('customFont');
        const customBackgroundColorParam = searchParams.get('customBackgroundColor');
        const customTextColorParam = searchParams.get('customTextColor');

        if (labelParam) {
            setLabel(labelParam);
        }
        if (designParam) {
            setDesign(designParam);
        }
        if (contactParam) {
            setContact(contactParam);
        }
        if (customColorParam) {
            setCustomColor(customColorParam);
        }
        if (customFontParam) {
            setCustomFont(customFontParam);
        }
        if (customBackgroundColorParam) {
            setCustomBackgroundColor(customBackgroundColorParam);
        }
        if (customTextColorParam) {
            setCustomTextColor(customTextColorParam);
        }
    }, [location.search, location.hash]);

    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: "/customcall",
            title: "Call Custom AI Dental Assistant"
        });
    }, []);

    useEffect(() => {
        const script1 = document.createElement('script');
        script1.src = 'https://fast.wistia.com/embed/medias/twrn63czfj.jsonp';
        script1.async = true;
        document.body.appendChild(script1);

        const script2 = document.createElement('script');
        script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
        script2.async = true;
        document.body.appendChild(script2);

        return () => {
            document.body.removeChild(script1);
            document.body.removeChild(script2);
        };
    }, []);

    useEffect(() => {
        if (window._wq) {
            window._wq = window._wq || [];
            window._wq.push({
                id: 'mh313ag1y4',
                options: {
                    playerColor: "#7128d7",
                    stillUrl: "https://fast.wistia.com/embed/medias/twrn63czfj/swatch"
                },
                onReady: (video) => {
                    video.bind('play', () => {
                        ReactGA.event({
                            category: 'Video',
                            action: 'Play',
                            label: 'AI Teammates for Dentists'
                        });
                    });

                    video.bind('pause', () => {
                        ReactGA.event({
                            category: 'Video',
                            action: 'Pause',
                            label: 'AI Teammates for Dentists'
                        });
                    });

                    video.bind('end', () => {
                        ReactGA.event({
                            category: 'Video',
                            action: 'Ended',
                            label: 'AI Teammates for Dentists'
                        });
                    });

                    video.bind('percentwatchedchanged', (percent) => {
                        if (percent >= 25 && !video.reached25) {
                            video.reached25 = true;
                            ReactGA.event({
                                category: 'Video',
                                action: 'Progress 25%',
                                label: 'AI Teammates for Dentists'
                            });
                        }
                        if (percent >= 50 && !video.reached50) {
                            video.reached50 = true;
                            ReactGA.event({
                                category: 'Video',
                                action: 'Progress 50%',
                                label: 'AI Teammates for Dentists'
                            });
                        }
                        if (percent >= 75 && !video.reached75) {
                            video.reached75 = true;
                            ReactGA.event({
                                category: 'Video',
                                action: 'Progress 75%',
                                label: 'AI Teammates for Dentists'
                            });
                        }
                    });
                }
            });
        }
    }, []);
    const LoadingContent = ({ text }) => (
        <div className="fixed inset-0 flex items-center justify-center bg-[#7128d7] bg-opacity-5">
            <div className="text-center">
                <h1 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-8">
                    {text}
                </h1>
                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-white mx-auto"></div>
            </div>
        </div>
    );

    const MainContent = () => (
        <div className="flex min-h-screen items-center justify-center p-2 sm:p-4 bg-inherit">
            <div className="w-full max-w-sm sm:max-w-md">
                {vipConfig ? (
                    <VIPSimpleCallCard
                        vipId={vipId}
                        vipConfig={vipConfig}
                        label={label}
                        design={design}
                        contact={contact}
                        token={token}
                        submitInfo={submitInfo}
                        customColor={customColor}
                        customFont={customFont}
                        customBackgroundColor={customBackgroundColor}
                        customTextColor={customTextColor}
                    />
                ) : (
                    <LoadingContent text="No Such User..." />
                )}
            </div>
        </div>
    );

    return isLoading ? <LoadingContent text="Loading your AI Receptionist..." /> : <MainContent />;
};

export default VIPPage;

